import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';

const CertificationTestExecutionListPendingReview = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Course',
        path: 'course.name',
      },
      {
        label: 'Student',
        path: 'student.name',
      },
      {
        label: 'Company',
        path: 'student.company.name',
      },
      {
        label: 'Started At',
        path: 'startedAt',
        render: (cell) => cell && moment(cell).format('DD/MM/YYYY HH:mm'),
      },
      {
        label: 'Completed At',
        path: 'completedAt',
        render: (cell) => cell && moment(cell).format('DD/MM/YYYY HH:mm'),
      },
      {
        label: 'Reading Score',
        path: 'readingScore',
      },
      {
        label: 'Listening Score',
        path: 'listeningScore',
      },
      {
        label: 'Actions',
        path: 'action',
        width: '85px',
        render: (cell, row) => (
          <Button
            icon="export"
            onClick={() => browserHistory.push(`/certification-test-executions/${row.id}/details`)}
          />
        ),
      },
    ]}
    rows={props.certificationTests}
    pagination={props.pagination}
    onChange={props.onChange}
  />
);

CertificationTestExecutionListPendingReview.propTypes = {
  certificationTests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CertificationTestExecutionListPendingReview;
